/* eslint react/no-unknown-property: 0 */

import { Mesh, MeshStandardMaterial, MeshPhysicalMaterial } from 'three'

import React from 'react'
import { I3DModelProps } from '../types'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three-stdlib'
import useScreenTexture from 'hooks/useScreenTexture'

type GLTFResult = GLTF & {
  nodes: {
    Plane: Mesh
    Plane_1: Mesh
    Plane_2: Mesh
    Plane_3: Mesh
    Plane_4: Mesh
    Screen: Mesh
  }
  materials: {
    metal: MeshStandardMaterial
    ['matte black']: MeshPhysicalMaterial
    glass: MeshPhysicalMaterial
    black: MeshStandardMaterial
    ['glass type 2']: MeshPhysicalMaterial
    Material: MeshStandardMaterial
  }
}

export default function TabletVerticalModel({
  setRef = () => null,
  screenMedia,
  ...props
}: I3DModelProps) {
  const { nodes, materials } = useGLTF('/assets/3dmodels/tablet/tablet_vertical.glb') as GLTFResult
  const screenRef = useScreenTexture(screenMedia)

  return (
    <group ref={setRef} {...props} dispose={null}>
      <mesh geometry={nodes.Screen.geometry} material={materials.Material}>
        <meshBasicMaterial color="black" />
        <meshBasicMaterial ref={screenRef} toneMapped={false} />
      </mesh>
      <mesh geometry={nodes.Plane.geometry} material={materials.metal} />
      <mesh geometry={nodes.Plane_1.geometry} material={materials['matte black']} />
      <mesh geometry={nodes.Plane_2.geometry} material={materials.glass} />
      <mesh geometry={nodes.Plane_3.geometry} material={materials.black} />
      <mesh geometry={nodes.Plane_4.geometry} material={materials['glass type 2']} />
    </group>
  )
}

useGLTF.preload('/assets/3dmodels/tablet/tablet_vertical.glb')
